import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronDown } from 'lucide-react';
const tomos = [{
  num: 'T1',
  title: 'DOMINÁ EL SET PIECE: LA BASE DE TODO',
  desc: 'Lo que la mayoría aprende mal desde el baby rugby y ningún DT de club se toma el tiempo de corregir. Comprende la mecánica detrás de cada set piece. Aprendé a posicionarte en el scrum, ejecutar el line-out y generar presión coordinada para dominar cada fase estática.',
  bullets: ['Técnica de scrum: binding, empuje y señales internas', 'Line-out: saltadores, throws y señas de club', 'Patadas de reinicio: estrategia y posicionamiento UAR', 'Cómo leer el set piece rival antes de que ejecuten']
}, {
  num: 'T2',
  title: 'PHASE PLAY: HACÉ QUE CADA FASE CUENTE',
  desc: 'El juego de fases que practica San Isidro Club y que tu equipo puede aprender hoy mismo.',
  bullets: ['Ruck y maul: cuándo entrar, cuándo no y por qué', 'Líneas de corrida que abren defensas en canchas de club', 'Pick and go: el arma de los forwards inteligentes', 'Recycling rápido como los Pumas en el Rugby Championship']
}, {
  num: 'T3',
  title: 'DEFENDÉ COMO LOS PUMAS',
  desc: 'La defensa que clasifica al seleccionado provincial y te pone en el radar del cuerpo técnico.',
  bullets: ['Sistemas defensivos que usan los equipos de la URBA', 'Tackle técnico que no lesiona y sí detiene al rival', 'Línea defensiva: spacing, comunicación y presión', 'El jugador defensivo que todo DT argentino quiere']
}, {
  num: 'T4',
  title: 'EL FÍSICO QUE TE PONE EN PRIMERA',
  desc: 'El acondicionamiento que podés hacer con lo que tenés en tu club hoy mismo.',
  bullets: ['Periodización para la temporada de la Unión', 'Trabajo físico sin gimnasio de alto rendimiento', 'Fuerza funcional para forwards y backs argentinos', 'Plan semanal compatible con trabajar o estudiar']
}, {
  num: 'T5',
  title: 'PENSÁ MÁS RÁPIDO QUE EL RIVAL',
  desc: 'Lo que separa al jugador de club del jugador que llega a la Selección Provincial.',
  bullets: ['Toma de decisiones en menos de 2 segundos', 'Cómo estudiar al rival antes del partido del sábado', 'Control emocional en los últimos 10 minutos', 'Liderazgo desde cualquier posición del equipo']
}, {
  num: 'T6',
  title: 'NUTRICIÓN Y RECUPERACIÓN',
  desc: 'Cómo alimentarte bien con el presupuesto de un rugbier argentino real.',
  bullets: ['Qué comer antes del partido del sábado sin gastar fortuna', 'Recuperación después de 80 minutos de rugby físico', 'Suplementación inteligente y accesible en Argentina', 'Plan nutricional para el rugbier que trabaja o estudia']
}];
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-24 bg-rugby-green-950 relative pattern-lines" data-id="element-369">
      <div className="container mx-auto px-4" data-id="element-370">
        <div className="max-w-6xl mx-auto" data-id="element-371">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-372">
            <span className="text-rugby-gold-400 font-bold tracking-widest uppercase text-xs md:text-sm mb-2 block" data-id="element-373">
              Contenido Completo
            </span>
            <h2 className="text-3xl md:text-6xl font-display text-white mb-2 md:mb-4" data-id="element-374">
              LOS 6 TOMOS
            </h2>
            <p className="text-sm md:text-xl text-slate-300 font-serif italic px-2" data-id="element-375">
              Tu hoja de ruta para dominar el rugby argentino moderno
            </p>
          </motion.div>

          {/* MOBILE: Accordion. DESKTOP: Grid */}

          {/* Mobile Accordion */}
          <div className="md:hidden space-y-3" data-id="element-376">
            {tomos.map((tomo, i) => {
            const isOpen = openIndex === i;
            return <motion.div key={i} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className={`bg-rugby-green-900 border rounded-xl overflow-hidden transition-colors ${isOpen ? 'border-rugby-gold-500/60' : 'border-rugby-green-700'}`} data-id="element-377">
                  <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full p-4 flex items-center gap-3 text-left" data-id="element-378">
                    <div className="bg-gradient-to-br from-rugby-gold-400 to-rugby-gold-600 text-rugby-green-950 font-display text-xl w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 shadow-[0_0_12px_rgba(212,175,55,0.3)]" data-id="element-379">
                      {tomo.num}
                    </div>
                    <h3 className="text-sm font-bold text-white leading-snug flex-1" data-id="element-380">
                      {tomo.title}
                    </h3>
                    <ChevronDown size={18} className={`text-rugby-gold-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-381" />
                  </button>
                  <AnimatePresence data-id="element-382">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-383">
                        <div className="px-4 pb-4 pt-1 border-t border-rugby-green-800/60" data-id="element-384">
                          <p className="text-slate-300 text-sm leading-relaxed mb-4 mt-3" data-id="element-385">
                            {tomo.desc}
                          </p>
                          <div className="space-y-2" data-id="element-386">
                            {tomo.bullets.map((bullet, j) => <div key={j} className="flex items-start gap-2" data-id="element-387">
                                <div className="mt-0.5 bg-rugby-green-800 p-0.5 rounded flex-shrink-0" data-id="element-388">
                                  <Check size={12} className="text-rugby-gold-400" data-id="element-389" />
                                </div>
                                <span className="text-slate-200 text-xs leading-snug" data-id="element-390">
                                  {bullet}
                                </span>
                              </div>)}
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-391">
            {tomos.map((tomo, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: i * 0.1
          }} whileHover={{
            y: -4
          }} className="bg-rugby-green-900 border border-rugby-green-700 rounded-2xl overflow-hidden flex flex-col h-full shadow-xl hover:border-rugby-gold-500/40 transition-colors" data-id="element-392">
                <div className="bg-rugby-green-950 p-6 border-b border-rugby-green-800 flex items-start gap-4" data-id="element-393">
                  <div className="bg-gradient-to-br from-rugby-gold-400 to-rugby-gold-600 text-rugby-green-950 font-display text-3xl w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0 shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-394">
                    {tomo.num}
                  </div>
                  <div data-id="element-395">
                    <h3 className="text-xl font-bold text-white leading-tight" data-id="element-396">
                      {tomo.title}
                    </h3>
                  </div>
                </div>

                <div className="p-6 flex-grow flex flex-col" data-id="element-397">
                  <p className="text-slate-300 mb-6 leading-relaxed" data-id="element-398">
                    {tomo.desc}
                  </p>

                  <div className="mt-auto space-y-3" data-id="element-399">
                    {tomo.bullets.map((bullet, j) => <div key={j} className="flex items-start gap-3" data-id="element-400">
                        <div className="mt-1 bg-rugby-green-800 p-0.5 rounded flex-shrink-0" data-id="element-401">
                          <Check size={14} className="text-rugby-gold-400" data-id="element-402" />
                        </div>
                        <span className="text-slate-200 text-sm" data-id="element-403">{bullet}</span>
                      </div>)}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}